import { navigate } from '@reach/router'
import * as routes from 'src/constants/routes'
import HttpError from './HttpError'

/* eslint-enable no-param-reassign */
export function unauthenticatedError(err: HttpError): Promise<unknown> {
  if (err.name === 'HttpError' && err.status === 401) {
    navigate(routes.NO_AUTH)
  }
  return Promise.resolve()
}
